import React from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const options = ["Bat", "Ball"];

export const BatOrBallWheelPage: React.FC = () => {
  const [spinning, setSpinning] = React.useState(false);
  const [result, setResult] = React.useState<string | null>(null);
  const navigate = useNavigate();

  const spinWheel = () => {
    setSpinning(true);
    setResult(null);
    setTimeout(() => {
      const res = options[Math.floor(Math.random() * options.length)];
      setResult(res);
      setSpinning(false);
    }, 1800);
  };

  return (
    <VStack minH="100vh" justify="center" align="center" bgGradient="linear(to-b, #e0eafc, #cfdef3)">
      <Box position="absolute" top={4} left={4}>
        <Button onClick={() => navigate(-1)} variant="ghost" colorScheme="teal">Back</Button>
      </Box>
      <Heading size="2xl" color="#01579b" mb={2}>Bat or Ball Wheel</Heading>
      <Text fontSize="lg" color="#333" mb={6} textAlign="center">
        Spin the wheel to randomly select Bat or Ball!
      </Text>
      <Box
        w={220}
        h={220}
        borderRadius="full"
        bgGradient="conic-gradient(#2b6cb0 0% 50%, #f6ad55 50% 100%)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="2xl"
        mb={6}
        position="relative"
        transition="transform 1.8s cubic-bezier(.17,.67,.83,.67)"
        style={{
          transform: spinning ? `rotate(${Math.random() * 1440 + 1440}deg)` : "rotate(0deg)",
        }}
      >
        <Text fontSize="3xl" color="#fff" fontWeight="bold" position="absolute" left="25%" top="45%">Bat</Text>
        <Text fontSize="3xl" color="#fff" fontWeight="bold" position="absolute" right="25%" top="45%">Ball</Text>
        <Box
          position="absolute"
          top={-6}
          left="50%"
          transform="translateX(-50%)"
          w={0}
          h={0}
          borderLeft="12px solid transparent"
          borderRight="12px solid transparent"
          borderBottom="24px solid #e53e3e"
        />
      </Box>
      <Button colorScheme="teal" size="lg" onClick={spinWheel} loading={spinning}>
        Spin Wheel
      </Button>
      {result && (
        <Text fontSize="2xl" color="teal.600" mt={4} fontWeight="bold">
          Result: {result}
        </Text>
      )}
    </VStack>
  );
};

export default BatOrBallWheelPage;
